export enum PermissionsSlugs {
  canCreateUsers = "backoffice.create.user",
  canCreateRoles = "backoffice.create.roles",
  canViewMerchants = "backoffice.view.merchant",
  canViewMerchantDetails = "backoffice.view.merchant.detail",
  canViewPendingPurchasesAsCS = "backoffice.view.purchase.cs",
  canViewPendingPurchasesAsFinance = "backoffice.view.purchase.finances",
  isCSMember = "backoffice.approve.cs",
  isFinanceMember = "backoffice.approve.finance",
  canViewUsers = "backoffice.view.user",
  canViewRoles = "backoffice.view.roles",
  canViewMazeedCategories = "backoffice.mazeed.view.categories",
  canViewMazeedCategoryDetails = "backoffice.mazeed.view.detail.categories",
  canEditMazeedCategory = "backoffice.mazeed.edit.categories",
  canEditMazeedCategoryScore = "backoffice.mazeed.edit.score.categories",
  canDeleteMazeedCategory = "backoffice.mazeed.delete.categories",
  canViewMazeedStores = "backoffice.mazeed.view.store",
  canViewMazeedStoreDetails = "backoffice.mazeed.view.store.detail",
  canViewCountries = "backoffice.view.country",
  canViewCurrencies = "backoffice.view.currencies",
  canViewCurrenciesTwo = "view.currencies",
  canEditCountries = "backoffice.update.country",
  canEditCity = "backoffice.update.city",
  canDeactivateCity = "backoffice.deactivate.city",
  canViewMazeedProducts = "backoffice.mazeed.view.product",
  canViewMazeedProductDetails = "backoffice.mazeed.view.product.detail",
  canAcceptRejectMazeedProduct = "backoffice.mazeed.accept.reject.product",
  canBlockUnblockMazeedProduct = "backoffice.mazeed.block.unblock.product",
  canViewMazeedBanners = "backoffice.mazeed.view.banners",
  canViewMazeedBannersDetails = "backoffice.mazeed.view.banners.detail",
  canCreateMazeedBanners = "backoffice.mazeed.view.create.banners",
  canEditMazeedBanners = "backoffice.mazeed.view.create.edit.banners",
  canViewOffersCoupons = "backoffice.view.coupons.offers",
  canCreateOffersCoupons = "backoffice.create.coupons.offers",
  canEditOffersCoupons = "backoffice.update.coupons.offers",
  canCreateProducts = "khabeer.create.products",
  canEditProducts = "khabeer.edit.products",
  canDeleteProducts = "khabeer.delete.products",
  canViewProducts = "khabeer.view.products",
  canViewCorePackages = "khabeer.view.core.package",
  canViewMazeedOrders = "backoffice.mazeed.view.orders",
  canViewMazeedOrderDetails = "backoffice.mazeed.view.order.detail",
  canViewCustomers = "backoffice.mazeed.view.customers",
  canEditCustomers = "backoffice.mazeed.edit.customers",
  canViewMazeedCoupons = "backoffice.mazeed.view.coupon",
  canCreateMazeedCoupon = "backoffice.mazeed.view.coupon.create",
  canEditMazeedCoupon = "backoffice.mazeed.view.coupon.edit",
  canDeleteMazeedCoupon = "backoffice.mazeed.view.coupon.edit.delete",
  canViewMazeedSettlements = "backoffice.mazeed.view.settlements",
  canApproveRejectMazeedStore = "backoffice.mazeed.accept.reject.store",
  canApproveRejectMazeedSettlement = "backoffice.mazeed.view.accept.reject.settlements",
  canEditCommissionRates = "backoffice.mazeed.edit.commission.rate",
  canEditPermissions = "backoffice.update.role.permissions",
  CanEditUserRole = "backoffice.update.user.role",
  canUseZamTools = "backoffice.enable.tool.zam",
  canAddPrivateApp = "backoffice.add.private.app",
  canUseSwitcherTools = "backoffice.enable.tool.switchers",
  canStartSwitcherCampaign = "backoffice.start.switcher.campaign",
  canUseSubscriptionTools = "backoffice.enable.tool.subscriptions",
  canViewSmsProviderSettings = "backoffice.view.sms.provider.settings",
  canManageSmsProviderSettings = "backoffice.manage.sms.provider.settings",
  canManageLegacySmsProviderSettings = "backoffice.manage.sms.providers",
  canDeleteStores = "backoffice.delete.merchant",
  canActivateEnterprisePackage = "khabeer.activate.enterprise.package",
  canActivateProfessionalTrialPackage = "khabeer.activate.professional.trial.package",
  canToggleStoresBlock = "backoffice.block.merchant",
  canViewCustomThemes = "backoffice.view.custom.themes",
  canLogoutStoreUsers = "backoffice.logout.allusers",
  canChangeMazeedOrdersStatus = "backoffice.mazeed.update.order.status",
  canViewThemes = "backoffice.view.themes",
  canUpdateThemes = "backoffice.update.themes",
  canBypassOrderStatusChangeRules = "backoffice.orders.bypass.status.change.restrictions",
  canViewZamPurchasables = "backoffice.view.coupons.zam.purchasables",
  canManagePaymentCards = "backoffice.manage.user.cards",
  canManageCommissions = "backoffice.manage.commissions",
  canSendMazeedProductReport = "backoffice.mazeed.send.product.report",
  canManageServiceFees = "backoffice.manage.servicefees",
  canExtendSubscriptionsAdvanced = "backoffice.enable.tool.subscriptions.advanced",
  ManageCache = "khabeer.manage.cache",
  canManagePosCashiers = "backoffice.manage.pos.cashiers",
  canManagePosPaymentMethods = "backoffice.manage.pos.paymentmethods",
  canEraseCustomer = "backoffice.delete.customer",
  canManageOneTimeOffers = "backoffice.manage.onetimeoffers",
}
